import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Globe, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Regions = () => {
  const { regions } = mockData;

  return (
    <section id="regions" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-semibold">
            Geographic Coverage
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-6 mb-4">
            47 Jurisdictions Across EMEA & APAC
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Primary source networks and government access across target markets
          </p>
        </div>

        {/* Regions Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {regions.map((region) => (
            <Card
              key={region.id}
              className="border-2 border-gray-100 hover:border-blue-200 hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <CardHeader>
                <div className="flex items-start justify-between mb-4">
                  <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300">
                    <Globe className="w-8 h-8 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <Badge className="bg-green-100 text-green-700 hover:bg-green-100">
                    Active
                  </Badge>
                </div>
                <CardTitle className="text-4xl font-bold text-gray-900 mb-4">
                  {region.name}
                </CardTitle>
                <div className="flex flex-col gap-2 text-sm text-gray-600 mb-4">
                  <div className="flex items-center gap-2">
                    <MapPin className="w-4 h-4 text-blue-600" />
                    <span className="font-semibold">{region.countries}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Globe className="w-4 h-4 text-blue-600" />
                    <span className="font-semibold">{region.jurisdictions}</span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 mb-6 leading-relaxed">{region.description}</p>
                <div className="flex flex-wrap gap-2">
                  {region.highlights.map((highlight, idx) => (
                    <Badge key={idx} variant="outline" className="border-blue-200 text-blue-700">
                      {highlight}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Map Visual */}
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <img
            src="https://images.pexels.com/photos/3769138/pexels-photo-3769138.jpeg?auto=compress&cs=tinysrgb&w=1200"
            alt="Global Coverage Map"
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 to-transparent flex items-end">
            <div className="p-8 md:p-12 text-white w-full">
              <div className="grid md:grid-cols-3 gap-8">
                <div>
                  <p className="text-4xl font-bold mb-2">47</p>
                  <p className="text-blue-100">Jurisdictions Covered</p>
                </div>
                <div>
                  <p className="text-4xl font-bold mb-2">70+</p>
                  <p className="text-blue-100">Years Network Access</p>
                </div>
                <div>
                  <p className="text-4xl font-bold mb-2">24/7</p>
                  <p className="text-blue-100">Real-Time Intelligence</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Regions;